// Extra referral fields we always surface in Raw Data (table + download)
// even when sparse/missing on individual rows. Populated once the
// VitalEngine referrals API includes them (sourced from rpt_referral).

export const REFERRAL_RAW_DATA_TYPES = new Set(['referrals', 'vitalrounds']);

export const ALWAYS_INCLUDE_REFERRAL_DATA_FIELDS = [
  'is_referred_by_non_vital_user',
  'is_referred_to_non_vital_user',
  'non_ve_physician_id',
];

export function isReferralRawDataType(dataType) {
  return REFERRAL_RAW_DATA_TYPES.has(dataType);
}
